import { createSlice } from '@reduxjs/toolkit';
import { Audition } from 'modules/auditions/services';

const submissionsSlice = createSlice({
  name: 'submissions',
  initialState: {
    sort: {
      [Audition.STATUSES.ACTIVE]: 'dueDate',
      [Audition.STATUSES.INACTIVE]: 'name',
    },
  },
  reducers: {
    setSort(state, action) {
      state.sort = { ...state.sort, ...action.payload };
    },
  },
  selectors: {
    getSort: state => state.sort,
  },
});
export const reducer = submissionsSlice.reducer;
export const { setSort } = submissionsSlice.actions;
export const { getSort } = submissionsSlice.selectors;
